import {ImagePickerProps} from '../components/image-picker';

export const getImagePicker =
  <T>(data: Omit<ImagePickerProps, 'type'>) =>
  (): ImagePickerProps => ({
    ...data,
    type: 'image-picker',
  });
